import { onAuthStateChanged, Unsubscribe } from "firebase/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { auth, deleteFavouriteShow } from "../firebase";
import { getDatabase, ref, onValue } from "firebase/database";
import { ShowType } from "../api";
import favouritesNotFound from "../img/undraw_empty_re_opql.svg";

const Favourites = () => {
  const navigate = useNavigate();
  const [favourites, setFavourites] = useState([] as ShowType[]);

  useEffect(() => {
    let watchingUnsubscribe: Unsubscribe | undefined = undefined;

    onAuthStateChanged(auth, (user) => {
      if (!user) navigate("/login");
      else {
        const db = getDatabase();
        const dbFavourites = ref(db, "users/" + auth.currentUser?.uid + "/favourites/");
        watchingUnsubscribe = onValue(dbFavourites, (snapshot) => {
          const data = snapshot.val();
          if (data) setFavourites(Object.values(data));
          else setFavourites([]);
        });
      }
    });

    return () => {
      if (watchingUnsubscribe) watchingUnsubscribe();
    };
  }, []);

  return (
    <>
      <Navbar page={"favourites"} />

      {favourites.length > 0 ? (
        <>
          <h1 className="text-3xl text-center	font-bold m-6 dark:text-slate-300">Favourites</h1>
          {favourites.map((favourite, key) => (
            <div key={key} className="m-5 flex items-center gap-3 ">
              <button onClick={() => navigate(`/detail/${favourite.id}`)}>
                <div
                  className="bg-cover rounded-full"
                  style={{
                    backgroundImage: `url(${favourite.image})`,
                    minWidth: "6rem",
                    minHeight: "6rem",
                  }}
                ></div>
              </button>
              <div className="space-y-0.5 overflow-hidden">
                <button onClick={() => navigate(`/detail/${favourite.id}`)}>
                  <p className="truncate text-lg text-black dark:text-slate-300 font-semibold">
                    {favourite.title}
                  </p>
                </button>
                <p className="truncate text-slate-500 dark:text-slate-600 font-medium">
                  {favourite.genres}
                </p>
              </div>
              <button
                className="ml-auto dark:text-slate-200"
                onClick={() => {
                  deleteFavouriteShow(favourite.id);
                }}
              >
                {/* prettier-ignore */}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7" > <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" /> </svg>
              </button>
            </div>
          ))}
        </>
      ) : (
        <div className="text-center mt-20">
          <img
            src={favouritesNotFound}
            className="mx-auto w-2/3 sm:w-2/4 lg:w-1/3"
            alt="No favourites found image"
          />
          <p className="mt-14 text-xl font-bold dark:text-slate-300">No Favourites Found</p>
          <p className="mt-4 mx-auto w-2/3 italic text-slate-500">
            You haven't added any shows to your favourites yet.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-800 font-semibold text-white rounded-full px-3 py-2 mt-5"
            onClick={() => {
              navigate("/home");
            }}
          >
            Home
          </button>
        </div>
      )}
    </>
  );
};
export default Favourites;
